<div
  class="toast notification bg-elevated relative w-full overflow-hidden rounded-md shadow-md"
  [style.--stripe-color]="stripeColor()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div class="flex items-start gap-2.5 py-2.5 pr-3 pl-5">
    <i [class]="iconClass()" class="mt-0.5 shrink-0 text-base"></i>

    <div class="min-w-0 flex-1">
      <p class="toast-title text-text-primary text-sm font-semibold">
        {{ notification().title }}
      </p>
      <p
        class="toast-message toast-message-scroll text-text-secondary mt-0.5 text-xs leading-relaxed break-words">
        {{ notification().message }}
      </p>

      @if (notification().actions) {
        <div class="mt-2 flex flex-wrap gap-1.5">
          @for (action of notification().actions; track action.label) {
            <button
              class="btn btn-sm"
              [class.btn-primary]="action.primary"
              [class.btn-cancel]="!action.primary"
              (click)="executeAction(action)">
              {{ action.label }}
            </button>
          }
        </div>
      }
    </div>

    <button
      (click)="onDismiss()"
      [attr.aria-label]="'common.close' | translate"
      class="btn btn-icon -mt-0.5 -mr-0.5 shrink-0 text-xs">
      <i [class]="ICONS.x"></i>
    </button>
  </div>

  @if (!isPersistent()) {
    <div
      class="countdown"
      [style.--countdown-duration]="(notification().duration ?? 5000) + 'ms'"></div>
  }
</div>
